import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
//import { ErrorHandler } from '../../../shared/ErrorHandler';
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';
import { Search } from '../../shared/user.model';

@Component({
  selector: 'app-pigmy-creation-grid',
  templateUrl: './pigmy-creation-grid.component.html',
  styleUrls: ['./pigmy-creation-grid.component.css']
})
export class PigmyCreationGridComponent implements OnInit {
  title="Pigmy Account List"
  itemsPerPage: number=5;
  currentPage: number=1;
  data: any = {};
  PigmyList : any = {};
  errorHandler: any;
  s: Search;
  isSearch: boolean;
  totalItems : number;
 
  constructor(private userService: UserService,private router: Router, private route: ActivatedRoute,
    private datepipe: DatePipe ) { }

  ngOnInit() {
    this.isSearch = false;
    this.GetAllData(this.itemsPerPage, 1)
    this.s = new Search();
   
  }
  // itemsPerPage(itemsPerPage: any, arg1: number) {
  //   throw new Error("Method not implemented.");
  // }

  GetAllData(itemsPerPage:any,pageNo:any){
    document.getElementById('loader-spinner').style.display = "block";

    this.data = this.userService.GetAllPigmyCreations(itemsPerPage,pageNo);
    this.data.subscribe(
    (response: any) => {   
      console.log('Data');
      console.log(response);
      // this.PigmyList = response;
      this.PigmyList = response.GetPigmycreationlist;
      this.totalItems = response.TotalItemsCount;
      this.itemsPerPage = itemsPerPage;
      this.currentPage = pageNo;
      document.getElementById('loader-spinner').style.display = "none";
      //swal('Success!', ' Pigmy Account created successfully.', 'success');           
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      // swal('Warning!', 'Something went wrong', 'warning');
    });
  }

  pageChanged(pageNumber: number) {
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else
      this.GetAllData(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else
      this.GetAllData(this.itemsPerPage, pageNo);
  }

//Search item


  onSearch(s, itemsPerPage: number, pageNo: number) { 

debugger;
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      // swal("Warning!", "Please enter the search criteria and search text.", "warning");
      alert("Warning!" );
    else {
      // document.getElementById('loader-spinner').style.display = "block";
      this.userService.SearchPigmyCreation(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data: any) => {
            if(data.GetPigmycreationlist.length!=0){              
            this.PigmyList = data.GetPigmycreationlist;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            // document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          // document.getElementById('loader-spinner').style.display = "none";         
          }
          }, (error) => {
            // document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              // swal('Warning!', error.error.Message, 'warning');
            }
          });
    }
  }



}




// WEBPACK FOOTER //
// ./src/app/master-account/pigmy-creation-grid/pigmy-creation-grid.component.ts